/* eslint-disable react-refresh/only-export-components -- hook and component are co-located */
import { createContext, useContext, useRef, ReactNode } from 'react';

interface AudioContextType {
  registerPlayer: (id: string, pauseFn: () => void) => void;
  unregisterPlayer: (id: string) => void;
  pauseAllExcept: (id: string) => void;
}

const AudioContext = createContext<AudioContextType | null>(null);

export function AudioProvider({ children }: { children: ReactNode }) {
  const playersRef = useRef<Map<string, () => void>>(new Map());

  const registerPlayer = (id: string, pauseFn: () => void) => {
    playersRef.current.set(id, pauseFn);
  };

  const unregisterPlayer = (id: string) => {
    playersRef.current.delete(id);
  };

  const pauseAllExcept = (id: string) => {
    playersRef.current.forEach((pauseFn, playerId) => {
      if (playerId !== id) {
        pauseFn();
      }
    });
  };

  return (
    <AudioContext.Provider value={{ registerPlayer, unregisterPlayer, pauseAllExcept }}>
      {children}
    </AudioContext.Provider>
  );
}

export function useAudioContext() {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudioContext must be used within AudioProvider');
  }
  return context;
}
